import { NodeModel } from '@shared/models/d3';

export class LinkModel implements d3.SimulationLinkDatum<NodeModel> {

  index?: number;

  source: NodeModel | string | number;
  target: NodeModel | string | number;

  constructor(source, target) {
    this.source = source;
    this.target = target;
  }
}
